// import logo from '../../assets/images/logo.png';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { createRef, useEffect, useState } from 'react';
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
// import login from '../../assets/images/logo.png'

import {
    InputGroup,
    InputRightElement,
    Spinner,
    useToast,
    Stack,
    Alert,
    AlertIcon,
    Checkbox,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';


import React from "react";
// Chakra imports
import {
    Box,
    Flex,
    Button,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    Switch,
    Text,
    DarkMode,
} from "@chakra-ui/react";

// Assets
import signInImage from "../../assets/images/signInImage.jpg";
import { useTranslation } from 'react-i18next';
import ReactCardFlip from 'react-card-flip';

import { motion, transform } from 'framer-motion'

export default function Register() {
    const { t } = useTranslation();

    const titleColor = "white";
    const textColor = "gray.400";
    const { setToken, isLoading, setIsLoading } = useStateContext()
    const [message, setMessage] = useState([])
    const toast = useToast()
    const navigate = useNavigate()

    const [isChecked, setIsChecked] = useState(false)

    const [first_name, setFirstName] = useState("")
    const [last_name, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [tel, setTel] = useState()
    const confirmPassword = createRef()

    const [passwordStrength, setPasswordStrength] = useState('');
    const [passwordColor, setPasswordColor] = useState('');
    const emailRegex = /^\S+@\S+\.\S+$/;

    const checkPasswordStrength = () => {
        const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
        const minLengthRegex = /^.{8,}$/;
        const startLength = /^.{2,}$/;
        const digitRegex = /\d/;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;

        let missingRequirements = [];

        if (!specialchar.test(password)) {
            missingRequirements.push("a special Character");
        } else if (!lowercaseRegex.test(password)) {
            missingRequirements.push("a lowercase letter");
        } else if (!uppercaseRegex.test(password)) {
            missingRequirements.push("an uppercase letter");
        } else if (!digitRegex.test(password)) {
            missingRequirements.push("a number");
        } else if (!minLengthRegex.test(password)) {
            missingRequirements.push("a minimum length of 8 characters");
        }

        if (missingRequirements.length > 0) {
            const missingText = `You need ${missingRequirements.join(", ")} in your password.`;
            setPasswordStrength(missingText);
            setPasswordColor('red.300');
        } else {
            setPasswordStrength('The password is correct !');
            setPasswordColor('green.300');
        }
    }
    const isFormValid = (password) => {
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*_|èàç()/."';:,?ù])[0-9a-zA-Z@#$%^&+=!*_|èàç()/."';:,?ù]{8,}$/;
        const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
        const minLengthRegex = /^.{8,}$/;
        const digitRegex = /\d/;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;

        let errors = [];

        if (!minLengthRegex.test(password)) {
            errors.push('The password must be at least 8 characters long.');
        }

        if (!digitRegex.test(password)) {
            errors.push('The password must contain at least one number.');
        }

        if (!lowercaseRegex.test(password)) {
            errors.push('The password must contain at least one lowercase letter.');
        }

        if (!uppercaseRegex.test(password)) {
            errors.push('The password must contain at least one uppercase letter.');
        }
        if (!specialchar.test(password)) {
            errors.push('The password must contain at least one special character (@#$%^&+=).');
        }
        if (password.length > 20) {
            errors.push('The password must not exceed 20 characters.');
        }

        if (errors.length > 0) {
            setMessage(errors[0]);
            return false;
        }

        return passwordRegex.test(password);
    };
    useEffect(() => {
        checkPasswordStrength();
    }, [password]);
    const onRegister = ev => {
        ev.preventDefault()
        // setIsLoading(true)
        toast.closeAll()

        // Check if the email exists in the dataDemandes array
        // const emailExistsInDemandes = dataDemandes.some((demande) => demande.email === email);

        // const emailExistsInApprenants = dataApprenants.some((apprenant) => apprenant.email === email);

        // if (emailExistsInApprenants) {
        //   setMessage({
        //     alert: "A user with the entered email already exists",
        //     target: "email",
        //   });
        //   setIsLoading(false);
        //   return;
        // }
        // else if (emailExistsInDemandes) {
        //   setMessage({
        //     alert: "A user with this email address already exists in the registration requests. Please wait while we process your request.",
        //     target: "email",
        //   });
        //   setIsLoading(false);
        //   return;
        // }


        const formData = new FormData()
        formData.append("first_name", first_name)
        formData.append("last_name", last_name)
        formData.append("email", email)
        formData.append("password", password)
        formData.append("tel", tel)
        formData.append("etat_demande", "EnCours")


        setMessage({})
        if (password !== confirmPassword.current.value) {
          setMessage({ alert: t("Veuillez confirmer le mot de passe."), target: "password" })
          setIsLoading(false)
          return
        } else if (passwordStrength !== 'Fort' && password.length > 0 && !isFormValid(password)) {
          setMessage({ alert: t("Entrer un mot de passe valide s'il vous plait."), target: "password" });
          setIsLoading(false)
          return;
        }

        else if (!emailRegex.test(email)) {
          setMessage({ alert: t("Please enter a valid email."), target: "email" });
          setIsLoading(false)
        }

        else {
        axiosClient.post('demandeInscription/', formData)
            .then(() => {
                //   setIsLoading(false)
                toast({
                    title: t("Demande envoyée"),
                    description: t("Votre demande a été soumise avec succès, veuillez attendre que votre compte soit validé."),
                    status: "success",
                    position: "top",
                    duration: 2000,
                    variant: 'left-accent',
                    isClosable: true,
                });

                  navigate('/login')
                  setFirstName()
                  setLastName()
                  setEmail()
                  setPassword()
                  setTel()
            })
            .catch((err) => {
                const response = err.response;
                // console.log(response);
                if (response.status === 400) {
                  setMessage({ alert: t("Ce mail existe déjà parmi les demandes d'inscription. Veuillez patienter pendant que nous traitons votre demande."), target: "email" });
                } else {
                  setMessage({ alert: response.data, target: "all" });
                }
                  setIsLoading(false);
            });
        }
    }
    const [showPassword, setShowPassword] = useState(false);
    const isFormFilled = email && password && tel && first_name && last_name ;

    return (
        <Flex position='relative' backgroundSize={'cover'} bgImage={signInImage} h={'100vh'} overflow="hidden">
            {/* Dark overlay */}
            <Box
                position="absolute"
                top={0} left={0} right={0} bottom={0}
                bg="blackAlpha.400"
                zIndex={0}
            />
            <Flex
                flexDirection={'row'} h={'100vh'} w={'100%'} position="relative" zIndex={1}>
                <Box
                    display={{ base: "none", lg: "flex" }}
                    flexDirection='column'
                    justifyContent='center'
                    alignItems='center'
                    px={6}
                    h={'100%'} w={{ lg: "40%", xl: "50%" }}
                    className="animate-fade-up"
                >
                    <Text
                        mb={3}
                        textAlign='center'
                        color='whiteAlpha.700'
                        letterSpacing='6px'
                        fontSize={{ lg: 'sm', xl: "md" }}
                        fontWeight='500'
                        textTransform="uppercase"
                    >
                        {t("BIENVENU DANS ECOLINKE")}
                    </Text>
                    <Text
                        textAlign='center'
                        color='transparent'
                        letterSpacing='8px'
                        fontSize={{ lg: '2xl', xl: "4xl" }}
                        fontWeight='800'
                        bgClip='text !important'
                        bg='linear-gradient(135deg, #FFFFFF 0%, #B794F4 50%, #9F7AEA 100%)'
                        lineHeight="1.2"
                    >
                        ECOLINKE
                    </Text>
                    <Box
                        mt={4}
                        h="2px"
                        w="60px"
                        bg="linear-gradient(90deg, transparent, rgba(159, 122, 234, 0.6), transparent)"
                        borderRadius="full"
                    />
                </Box>
                <Flex h={'100%'} w={{ base: "100%", lg: "60%", xl: '50%' }} alignItems={'center'} justifyContent={'center'}>
                    <Flex
                        w={{ base: "92%", sm: "85%", md: '65%', lg: '90%', xl: '75%' }}
                        backdropFilter='blur(20px) saturate(180%)'
                        WebkitBackdropFilter='blur(20px) saturate(180%)'
                        padding={{ base: 7, md: 9 }}
                        direction='column'
                        mr={{ base: 0, xl: 20 }}
                        rounded={"20px"}
                        background='rgba(20, 15, 40, 0.75)'
                        border="1px solid"
                        borderColor="whiteAlpha.100"
                        boxShadow="0 25px 60px -12px rgba(0,0,0,0.4), 0 0 40px -8px rgba(128, 90, 213, 0.1)"
                        className="animate-scale-in"
                        maxH="90vh"
                        overflowY="auto"
                        css={{
                            "&::-webkit-scrollbar": { width: "3px" },
                            "&::-webkit-scrollbar-thumb": { background: "rgba(255,255,255,0.15)", borderRadius: "10px" },
                        }}
                    >
                        <div style={{ zIndex: 999 }}>
                            <Heading
                                color={titleColor}
                                fontSize={{ base: '24px', md: '28px' }}
                                mb='24px'
                                fontWeight="800"
                                letterSpacing="-0.02em"
                            >
                                {t("Inscription")}
                            </Heading>
                            {message.alert &&
                                <Alert
                                    mb={4}
                                    status='error'
                                    rounded="12px"
                                    bg="rgba(254, 178, 178, 0.12)"
                                    border="1px solid"
                                    borderColor="rgba(254, 178, 178, 0.2)"
                                >
                                    <AlertIcon />
                                    <Text fontSize="13px" color="red.200">{message.alert}</Text>
                                </Alert>
                            }
                            <Flex gap={3}>
                                <FormControl mb="4" id="nom" isRequired >
                                    <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Nom")}</FormLabel>
                                    <Input
                                        color={titleColor}
                                        onChange={(e) => setLastName(e.target.value)}
                                        type="text"
                                        id='nom'
                                        placeholder={t('Tapez votre nom')}
                                        h="44px"
                                        bg="whiteAlpha.50"
                                        border="1px solid"
                                        borderColor="whiteAlpha.200"
                                        borderRadius="12px"
                                        fontSize="14px"
                                        _hover={{ borderColor: "whiteAlpha.300" }}
                                        _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                        _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                        transition="all 0.2s ease"
                                    />
                                </FormControl>
                                <FormControl mb="4" id="prenom" isRequired >
                                    <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Prénom")}</FormLabel>
                                    <Input
                                        color={titleColor}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        type="text"
                                        id='prenom'
                                        placeholder={t('Tapez votre prénom')}
                                        h="44px"
                                        bg="whiteAlpha.50"
                                        border="1px solid"
                                        borderColor="whiteAlpha.200"
                                        borderRadius="12px"
                                        fontSize="14px"
                                        _hover={{ borderColor: "whiteAlpha.300" }}
                                        _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                        _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                        transition="all 0.2s ease"
                                    />
                                </FormControl>
                            </Flex>

                            <FormControl mb={4} id="email" isRequired >
                                <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Adresse email")}</FormLabel>
                                <Input
                                    color={titleColor}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="text"
                                    id='email'
                                    placeholder={t('Tapez votre adresse email')}
                                    h="44px"
                                    bg="whiteAlpha.50"
                                    border="1px solid"
                                    borderColor="whiteAlpha.200"
                                    borderRadius="12px"
                                    fontSize="14px"
                                    _hover={{ borderColor: "whiteAlpha.300" }}
                                    _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                    _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                    transition="all 0.2s ease"
                                />
                            </FormControl>

                            <Flex gap={3} direction={{ base: 'column', md: 'row' }}>
                                <FormControl>
                                    <FormLabel mb="2" color="whiteAlpha.700" fontSize="13px" fontWeight="600" id='password'>{t("Mot de passe")}</FormLabel>
                                    <InputGroup mb="3">
                                        <Input
                                            color={titleColor}
                                            onChange={(e) => setPassword(e.target.value)}
                                            type={showPassword ? 'text' : 'password'}
                                            id='password'
                                            placeholder={t('Tapez votre mot de passe')}
                                            h="44px"
                                            bg="whiteAlpha.50"
                                            border="1px solid"
                                            borderColor="whiteAlpha.200"
                                            borderRadius="12px"
                                            fontSize="14px"
                                            _hover={{ borderColor: "whiteAlpha.300" }}
                                            _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                            _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                            transition="all 0.2s ease"
                                        />
                                        <InputRightElement h={'full'}>
                                            <Button
                                                color="whiteAlpha.600"
                                                variant={'ghost'}
                                                _hover={{ color: "white", bg: "whiteAlpha.100" }}
                                                borderRadius="lg"
                                                onClick={() =>
                                                    setShowPassword((showPassword) => !showPassword)
                                                }>
                                                {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                            </Button>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>
                                <FormControl>
                                    <FormLabel mb="2" color="whiteAlpha.700" fontSize="13px" fontWeight="600" id='confirmPassword'>{t("Confirmation mot de passe")}</FormLabel>
                                    <InputGroup mb="3">
                                        <Input
                                            color={titleColor}
                                            ref={confirmPassword}
                                            type={'password'}
                                            id='confirmPassword'
                                            placeholder={t('confirmez votre mot de passe')}
                                            h="44px"
                                            bg="whiteAlpha.50"
                                            border="1px solid"
                                            borderColor="whiteAlpha.200"
                                            borderRadius="12px"
                                            fontSize="14px"
                                            _hover={{ borderColor: "whiteAlpha.300" }}
                                            _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                            _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                            transition="all 0.2s ease"
                                        />
                                        {/* <InputRightElement h={'full'}>
                                            <Button
                                                color={titleColor}
                                                variant={'ghost'}
                                                _hover='none'
                                                onClick={() =>
                                                    setShowPassword((showPassword) => !showPassword)
                                                }>
                                                {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                            </Button>
                                        </InputRightElement> */}
                                    </InputGroup>
                                </FormControl>

                            </Flex>
                            {password.length > 0 ?
                                <Text align="left" justify="left" fontSize="12px" mb={3} color={passwordColor} fontWeight="500">{`${passwordStrength}`}</Text>

                                : ""}

                            <FormControl mb={4} id="tel" isRequired >
                                <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Numéro de téléphone")}</FormLabel>
                                <Input
                                    color={titleColor}
                                    onChange={(e) => setTel(e.target.value)}
                                    type="number"
                                    id='tel'
                                    placeholder={t('Tapez votre numéro de téléphone')}
                                    h="44px"
                                    bg="whiteAlpha.50"
                                    border="1px solid"
                                    borderColor="whiteAlpha.200"
                                    borderRadius="12px"
                                    fontSize="14px"
                                    _hover={{ borderColor: "whiteAlpha.300" }}
                                    _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                    _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                    transition="all 0.2s ease"
                                />
                            </FormControl>
                            <FormControl mb={3} id="cp"  >
                                <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Code parrainage")}</FormLabel>
                                <Checkbox
                                    mb={3}
                                    color={titleColor}
                                    isChecked={isChecked}
                                    onChange={(e) => setIsChecked(e.target.checked)}
                                    colorScheme="purple"
                                    size="sm"
                                >
                                    <Text fontSize="13px" color="whiteAlpha.700">{t("Avez-vous un code parrainage ?")}</Text>
                                </Checkbox>
                                {isChecked &&
                                    <Input
                                        color={titleColor}
                                        type="text"
                                        id='email'
                                        placeholder={t('code parrainage')}
                                        h="44px"
                                        bg="whiteAlpha.50"
                                        border="1px solid"
                                        borderColor="whiteAlpha.200"
                                        borderRadius="12px"
                                        fontSize="14px"
                                        _hover={{ borderColor: "whiteAlpha.300" }}
                                        _focus={{ borderColor: "purple.400", boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)", bg: "whiteAlpha.100" }}
                                        _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                        transition="all 0.2s ease"
                                    />
                                }
                            </FormControl>



                            <Stack spacing={6} mt={4}>
                                <Button
                                    fontSize='14px'
                                    fontWeight="600"
                                    h="48px"
                                    type="submit"
                                    colorScheme='purple'
                                    onClick={onRegister}
                                    isLoading={isLoading}
                                    isDisabled={!isFormFilled}
                                    borderRadius="12px"
                                    bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
                                    _hover={{
                                        bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                                        transform: "translateY(-1px)",
                                        boxShadow: "0 8px 25px -5px rgba(128, 90, 213, 0.4)"
                                    }}
                                    _active={{ transform: "scale(0.98)" }}
                                    transition="all 0.2s ease"
                                    letterSpacing="-0.01em"
                                >
                                    {isLoading ? <Spinner size="sm" /> : t("S'inscrire")}
                                </Button>
                            </Stack>

                            <Flex gap={2} mt={4} justify="center">
                                <Text color="whiteAlpha.500" fontSize="13px">{t('Vous avez déjà un compte ?')}</Text>
                                <Text
                                    color='purple.300'
                                    fontWeight="600"
                                    fontSize="13px"
                                    cursor='pointer'
                                    _hover={{ color: "purple.200" }}
                                    transition="color 0.15s ease"
                                    onClick={() => navigate('/login')}
                                >
                                    {t("Se connecter")}
                                </Text>
                            </Flex>

                        </div>

                    </Flex>

                </Flex>
            </Flex>


        </Flex>
    );
}

